import React from 'react';
import './HeroBox.css';
import { Link } from 'react-router-dom';

const AdBoxes = () => {
  return (
    <div className="ad-container">
      <div className="ad-bbox left">
        <img src="/images/card2.png" alt="Business Cards" />
        <div className="ad-content">
          <h3>Business Cards Printing</h3>
          <p>Get high-quality business cards that leave a lasting impression.</p>
          <Link to="/category/Business_Cards">
            <button className="btn">Order Now</button>
          </Link>
        </div>
      </div>
      <div className="ad-bbox right">
        <img src="/images/shirt.png" alt="Custom T-Shirt Printing" />
        <div className="ad-content">
          <h3>Custom T-Shirt Printing</h3>
          <p>Create personalized T-shirts for your brand, events, or personal use.</p>
          <Link to="/category/Tshirt_Branding">
            <button className="btn">Order Now</button>
          </Link>
        </div>
      </div>
      <div className="ad-bbox left">
        <img src="/images/bus5.png" alt="Branded Mugs & Bags" />
        <div className="ad-content">
          <h3>Branded Mugs & Bags</h3>
          <p>Stylish, branded mugs and bags, perfect for corporate giveaways.</p>
          <Link to="/category/Bags">
            <button className="btn">Order Now</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AdBoxes;
